<div class="designation-form-container">
    <div class="designation-form-item-container">
    <div class="designation-form-item-input-container">
      <mat-form-field appearance="outline" class="designation-form-form-field">
        <mat-label>Designation for salt form</mat-label>
        <input matInput #designationInput [(ngModel)]="designation" class="designation-form designation-form-item-input"
          (keyup.enter)="updateDesignation($event)" (blur)="updateDesignation($event)" />
        <mat-icon matSuffix class="designation-form-item-trailing-icon" (mousedown)="clearDesignationInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('designationForSaltForm')">
      This is a required field.
    </div>
  </div>
  <div class="designation-form-info designation-form-info-text">Chemical Abstracts Service Index Name must be supplied any other systematic names for the substance may also be listed.</div>
</div>